<script setup lang="ts">
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import { type Elemental } from '~~/src/types/elemental'

const { elemental, listId } = defineProps<{
  elemental: Elemental
  route: string
  listId?: string | number
}>()

const { duplicate, isPending } = useDuplicate(elemental, listId)

defineOptions({
  name: 'DuplicateElementalOption',
})
</script>

<template>
  <MenuItem @select="duplicate">
    <template #icon>
      <IconDuplicate w-3 h-3 />
    </template>
    Duplicate
  </MenuItem>
  <Teleport v-if="isPending" to="body">
    <div class="absolute h-100[dvh] w-100[dvh] inset-0 z-999">
      <LoadingOverlay message="Duplicating..." />
    </div>
  </Teleport>
</template>
